import React, { useRef, useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { Box, Button, Chip, Grid, IconButton, Typography } from '@mui/material';
import LiqueModal from '../../customer/components/liqueModal';
import ImageCropper from './imageCropper';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { imageUrlToFile } from '../../helper/helperFunctions';

const ItemTypes = {
  ITEM: 'item',
};

function UploadImageSortableItem({
  image, 
  alt, 
  index, 
  moveItem, 
  cropable = false,
  cropAspectRatio = 1,
  deleteItem = () => {}, 
  replaceIitem = () => {}, 
}) {
  const ref = useRef(null);
  const imageUrl = process.env.REACT_APP_IMAGE_URL
  const [dialogOpen, setDialogOpen] = useState(false)
  const [cropItem, setCropItem] = useState(null);
  const [originalFile, setOriginalFile] = useState(null);
  
  const onCropItem = (image) => {
    replaceIitem(image, index, cropItem);
    setDialogOpen(false);
    setCropItem(null);
  }

  const onOpenDialog = async () => {
    if (typeof image === 'string') {
      const fetchImage = await imageUrlToFile(`${imageUrl}/${image}`, image);
      setCropItem(URL.createObjectURL(fetchImage));
    } else {
      setCropItem(image.preview);
      setOriginalFile(image?.baseFile || null);
    }

    setDialogOpen(true);
  } 

  const resetImage = async () => {
    if (typeof image !== 'string' && image.baseFile) {
      setCropItem(image.baseFile)
    }
  }

  const [, drop] = useDrop({
    accept: ItemTypes.ITEM,
    hover(item, monitor) {
      if (!ref.current) return;

      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) return;

      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const hoverMiddleX = (hoverBoundingRect.right - hoverBoundingRect.left) / 2;

      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      const hoverClientX = clientOffset.x - hoverBoundingRect.left;

      // Check if the drag crosses the middle of the item (works in both horizontal and vertical flex layouts)
      const isVerticalMove = hoverClientY > hoverMiddleY;
      const isHorizontalMove = hoverClientX > hoverMiddleX;

      if (dragIndex < hoverIndex && (isVerticalMove || isHorizontalMove)) return;
      if (dragIndex > hoverIndex && (!isVerticalMove || !isHorizontalMove)) return;

      moveItem(dragIndex, hoverIndex);
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.ITEM,
    item: { image, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref))

  return (
    <>
      <Grid item xs={4} sm={3} md={2} sx={{ opacity: isDragging ? 0.5 : 1 }}> 
        <div ref={ref} style={{ position: "relative" }}>
          {
            index === 0 && (
              <Box position="absolute" top="5px" right="5px" zIndex={2}>
                <Chip label="Main" size="small" color="success" />
              </Box>
            )
          }
          <div style={{ aspectRatio: cropAspectRatio, position: "relative" }}>
            {
              typeof image === 'string' ? (
                <img src={`${imageUrl}/${image}`} alt={image} style={{ aspectRatio: cropAspectRatio, objectFit: "cover", width: "100%" }}/>
              ) : (
                <img src={image.preview} alt={image.path}  style={{ aspectRatio: cropAspectRatio, objectFit: "cover", width: "100%" }}/>
              )
            }
            {
              cropable && (
                <Box position="absolute" bottom="10px" right="5px" zIndex={2}>
                  <IconButton sx={{ background: "white" }} onClick={onOpenDialog}>
                    <EditOutlinedIcon />
                  </IconButton>
                </Box>
              )
            }
          </div>
          <Button sx={{ background: "#E50B0B", color: "#fff", display: "block", width: "100%" }} onClick={() => deleteItem(image, index)}>
            Hapus
          </Button>
        </div>
      </Grid>

      <LiqueModal open={dialogOpen} onClose={() => setDialogOpen(false)} width={800}>
        <Box sx={{ padding: 2 }}>
          <ImageCropper
            imageSrc={cropItem}
            onCropDone={(img) => onCropItem(img)}
            aspectRatio={cropAspectRatio}
            originalFile={originalFile}
            resetImage={resetImage}
          />
        </Box>
      </LiqueModal>
    </>
  )
}

export default UploadImageSortableItem;